// extracted by mini-css-extract-plugin
module.exports = {"Slide":"SlideContainer_Slide__74PRn","MediaWrapper":"SlideContainer_MediaWrapper__3Y2qf"};